
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/premium/talent",
      function () {
        return require("private-next-pages/[locale]/premium/talent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/premium/talent"])
      });
    }
  